import type { UploadedFile } from '@/shared/components/form-fields/types';
import { formOptions } from '@tanstack/react-form';
import type { ProposalDecisionValues } from '../../types';

export const ACCEPT_FILE_MIME_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg',
  'image/png',
]);

export const ACCEPT_FILE_TYPES_STRING =
  'application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png';

export const MAX_ATTACHMENTS_COUNT = 5;
export const MAX_ATTACHMENT_SIZE_MB = 10;
const MAX_ATTACHMENT_SIZE_BYTES = MAX_ATTACHMENT_SIZE_MB * 1024 * 1024;

export const ATTACHMENTS_HELPER_TEXT = `Formatos aceitos: PDF, DOC, DOCX, JPG, JPEG, PNG. Máx. ${MAX_ATTACHMENTS_COUNT} arquivos de até ${MAX_ATTACHMENT_SIZE_MB}MB.`;

export const REJECTION_REASON_OPTIONS = [
  { value: 'risk_outside_acceptance', label: 'Risco fora do apetite' },
  { value: 'documental_inconsistency', label: 'Inconsistência documental' },
  { value: 'value_above_limit', label: 'Valor em risco acima do limite' },
  { value: 'activity_high_risk', label: 'Atividade de risco elevado' },
  { value: 'other', label: 'Outro motivo' },
];

export function validateAttachments(
  attachments: UploadedFile[] | undefined
): string | undefined {
  if (!attachments?.length) return undefined;
  if (attachments.length > MAX_ATTACHMENTS_COUNT) {
    return `Quantidade máxima de ${MAX_ATTACHMENTS_COUNT} arquivos.`;
  }
  const invalidType = attachments.find(
    file => !ACCEPT_FILE_MIME_TYPES.has(file.file.type)
  );
  if (invalidType) {
    return `Tipo de arquivo não permitido: ${invalidType.name}`;
  }
  const invalidSize = attachments.find(
    file => file.size > MAX_ATTACHMENT_SIZE_BYTES
  );
  if (invalidSize) {
    return `O arquivo ${invalidSize.name} excede ${MAX_ATTACHMENT_SIZE_MB}MB.`;
  }
  return undefined;
}

export const decisionFormOpts = formOptions({
  defaultValues: {
    status: null,
    acceptance: '',
    rejectionReason: '',
    rejectionObs: '',
    attachments: [],
  } as ProposalDecisionValues,
});
